import React, { Component } from 'react';
import ConversationForm from './components/ConversationForm';
import Login from './components/Login';
import './App.css';

import { BrowserRouter, Route } from 'react-router-dom';
import Navigation from "./components/Navigation";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code:''
    }
  }

  // get value from URL
  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");
      if(pair[0] === variable){return pair[1];}
    }
    return(false);
  }

  componentDidMount() {
    let authCode = this.getQueryVariable("code");
    this.setState({
      code: authCode
    });
  }

  render() {
    let contentPage = !this.state.code ? <Login/> : <ConversationForm code={this.state.code}/>
    return (
      <BrowserRouter>
        <div style={{height: "100%"}}>
          <Navigation/>
          {contentPage}
          <Route path="/login" component={Login} />
          <Route path="/conversation" component={ConversationForm} />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;